export default __webpack_public_path__ + "static/cdc4-842a736a6109d62e1eb321d362ed7969.jpg";